import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.semantic.SpaceComponentL}px; 0;
  background-color: ${({ theme }) => theme.semantic.BgSubtle};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-top: 40px;
  width: ${({ theme }) => theme.semantic.SizeIconL44};
  height: ${({ theme }) => theme.semantic.SizeIconL42};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const Title = styled(Typography)`
  margin: 0 0 ${({ theme }) => theme.semantic.SpaceComponentXl}px; 0;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const Description = styled(Typography)`
  margin: 0 0  ${({ theme }) => theme.semantic.SpaceComponentM}px; 0;
  color: ${({ theme }) => theme.semantic.FgDefault};
  text-align: left;
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const SubmitButton = styled(Button)`
  background-color: ${({ theme }) => theme.semantic.InteractionPrimary};
  color: ${({ theme }) => theme.semantic.FgOnColor};
  border-radius: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  cursor: pointer;
`;

export const DisclaimerText = styled(Typography)`
  text-align: left;
  color: ${({ theme }) => theme.semantic.FgContrast};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
`;
